/**
 * DIY Difficulty Rating Popup
 * Handles click interactions for the difficulty rating component
 */

class DifficultyRatingPopup {
  constructor() {
    this.popup = document.getElementById('difficulty-popup');
    this.badges = document.querySelectorAll('.difficulty-badge');
    this.closeBtn = document.querySelector('.difficulty-popup__close');
    this.overlay = document.querySelector('.difficulty-popup__overlay');
    this.sections = document.querySelectorAll('.difficulty-popup__section');
    this.currentLevel = null;
    
    this.init();
  }

  init() {
    console.log('Initializing Difficulty Rating Popup');
    console.log('Popup element:', this.popup);
    console.log('Badges found:', this.badges.length);
    
    if (!this.popup || this.badges.length === 0) {
      console.error('Popup or badges not found. Check your HTML structure.');
      return;
    }

    // Add click event listeners to badges
    this.badges.forEach(badge => {
      console.log('Adding listeners to badge:', badge.dataset.level);
      badge.addEventListener('click', (e) => {
        e.preventDefault();
        const level = badge.dataset.level;
        this.openPopup(level);
      });
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        this.closePopup();
      });
    }

    // Click outside to close
    document.addEventListener('click', (e) => {
      if (this.popup.classList.contains('is-active')) {
        // Check if click is outside popup and badges
        if (!this.popup.contains(e.target) && 
            !e.target.closest('.difficulty-badge')) {
          this.closePopup();
        }
      }
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('is-active')) {
        this.closePopup();
      }
    });
  }

  openPopup(level) {
    if (!level) {
      console.log('No level provided');
      return;
    }

    console.log('Opening popup for level:', level);
    
    // If already open and switching levels, animate content switch
    const isAlreadyOpen = this.popup.classList.contains('is-active');
    
    if (isAlreadyOpen) {
      // Add exit animation to current section
      this.sections.forEach(section => {
        if (section.classList.contains('is-active')) {
          section.classList.add('is-exiting');
        }
      });

      // Wait for exit animation, then switch content
      setTimeout(() => {
        // Hide all sections and remove exit class
        this.sections.forEach(section => {
          section.classList.remove('is-active', 'is-exiting');
        });

        // Show the selected difficulty section
        const activeSection = this.popup.querySelector(`[data-difficulty="${level}"]`);
        if (activeSection) {
          activeSection.classList.add('is-active');
        }
        
        // Recalculate position after content changes with small delay for rendering
        setTimeout(() => {
          this.updatePopupPosition();
        }, 10);
      }, 200); // Match exit animation duration
    } else {
      // First time opening - show immediately with animation
      // Hide all sections
      this.sections.forEach(section => {
        section.classList.remove('is-active');
      });

      // Show the selected difficulty section
      const activeSection = this.popup.querySelector(`[data-difficulty="${level}"]`);
      if (activeSection) {
        activeSection.classList.add('is-active');
      }

      // Show popup with smooth animation
      this.popup.style.display = 'block';
      this.popup.classList.remove('is-closing');
      
      // Use requestAnimationFrame for smooth animation and positioning
      requestAnimationFrame(() => {
        // Add small delay to ensure content is fully rendered
        setTimeout(() => {
          this.updatePopupPosition();
        }, 10);
        this.popup.classList.add('is-active');
      });
    }

    this.currentLevel = level;
  }

  updatePopupPosition() {
    // Calculate position to be 20px above the DIY Difficulty Rating heading
    const difficultyTitle = document.querySelector('.difficulty-title');
    const difficultyWrapper = this.popup.closest('.difficulty-wrapper');
    
    if (difficultyTitle && difficultyWrapper) {
      // Force a reflow to get accurate dimensions
      this.popup.offsetHeight;
      
      const popupHeight = this.popup.offsetHeight;
      const titleRect = difficultyTitle.getBoundingClientRect();
      const wrapperRect = difficultyWrapper.getBoundingClientRect();
      
      // Calculate the offset from the top of the wrapper to the top of the title
      const titleOffsetFromWrapper = titleRect.top - wrapperRect.top;
      
      // Position so bottom of popup is 20px above the title
      // Formula: -(popup height) - (distance from wrapper top to title top) - 20px spacing
      this.popup.style.top = `${-popupHeight - titleOffsetFromWrapper - 20}px`;
    }
  }

  closePopup() {
    // Add closing animation
    this.popup.classList.add('is-closing');
    this.popup.classList.remove('is-active');
    
    // Hide popup after animation completes
    setTimeout(() => {
      this.popup.style.display = 'none';
      this.popup.classList.remove('is-closing');
      this.currentLevel = null;
      
      // Clean up any active sections
      this.sections.forEach(section => {
        section.classList.remove('is-active', 'is-exiting');
      });
    }, 300); // Match the CSS transition duration
  }

}

// Store instance to prevent multiple initializations
let difficultyPopupInstance = null;

// Initialize function
function initDifficultyPopup() {
  console.log('Attempting to initialize Difficulty Rating Popup...');
  const popup = document.getElementById('difficulty-popup');
  const badges = document.querySelectorAll('.difficulty-badge');
  
  if (popup && badges.length > 0) {
    console.log('Elements found, initializing...');
    // Only create one instance
    if (!difficultyPopupInstance) {
      difficultyPopupInstance = new DifficultyRatingPopup();
      // Expose globally for debugging
      window.difficultyPopup = difficultyPopupInstance;
      console.log('✅ Difficulty Rating Popup initialized successfully!');
      console.log('💡 Test it by typing: window.difficultyPopup.openPopup("easy")');
    }
  } else {
    console.warn('Waiting for elements... Popup:', !!popup, 'Badges:', badges.length);
    // Retry after a short delay (max 5 retries)
    if (!initDifficultyPopup.retryCount) initDifficultyPopup.retryCount = 0;
    if (initDifficultyPopup.retryCount < 5) {
      initDifficultyPopup.retryCount++;
      setTimeout(initDifficultyPopup, 500);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDifficultyPopup);
} else {
  initDifficultyPopup();
}

// Reinitialize on Shopify section render (for theme editor and dynamic content)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    console.log('Shopify section loaded, reinitializing...');
    new DifficultyRatingPopup();
  });
}

// Also listen for product variant changes in case content reloads
document.addEventListener('variant:change', () => {
  console.log('Product variant changed, checking popup...');
  setTimeout(initDifficultyPopup, 100);
});

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initDisclaimerPopup();
  }



  
  /**
   * Initialize disclaimer popup functionality
   */
  function initDisclaimerPopup() {
    const disclaimerTrigger = document.getElementById('difficulty-disclaimer-trigger');
    const disclaimerPopup = document.getElementById('difficulty-disclaimer-popup');
    
    if (!disclaimerTrigger || !disclaimerPopup) {
      return;
    }

    const closeButton = disclaimerPopup.querySelector('.difficulty-disclaimer-popup__close');
    
    // Open popup when clicking disclaimer text
    disclaimerTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openDisclaimerPopup();
    });

    // Close popup when clicking close button
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.preventDefault();
        closeDisclaimerPopup();
      });
    }

    // Close popup when clicking outside the content
    document.addEventListener('click', function(e) {
      if (disclaimerPopup.classList.contains('is-active')) {
        // Check if click is outside popup and trigger
        if (!disclaimerPopup.contains(e.target) && 
            !e.target.closest('#difficulty-disclaimer-trigger')) {
          closeDisclaimerPopup();
        }
      }
    });

    // Close popup on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && disclaimerPopup.classList.contains('is-active')) {
        closeDisclaimerPopup();
      }
    });
  }

  /**
   * Open disclaimer popup
   */
  function openDisclaimerPopup() {
    const disclaimerPopup = document.getElementById('difficulty-disclaimer-popup');
    const disclaimerTrigger = document.getElementById('difficulty-disclaimer-trigger');
    if (!disclaimerPopup || !disclaimerTrigger) return;

    // Show popup first to get accurate dimensions
    disclaimerPopup.style.display = 'block';
    disclaimerPopup.classList.remove('is-closing');
    
    // Use requestAnimationFrame for smooth animation and positioning
    requestAnimationFrame(() => {
      // Add small delay to ensure content is fully rendered
      setTimeout(() => {
        updateDisclaimerPopupPosition(disclaimerPopup, disclaimerTrigger);
      }, 10);
      
      disclaimerPopup.classList.add('is-active');
    });
  }

  /**
   * Update disclaimer popup position
   */
  function updateDisclaimerPopupPosition(disclaimerPopup, disclaimerTrigger) {
    // Force a reflow to get accurate dimensions
    disclaimerPopup.offsetHeight;
    
    // Get actual popup dimensions after display
    const popupRect = disclaimerPopup.getBoundingClientRect();
    const popupHeight = popupRect.height;
    const popupWidth = popupRect.width;
    
    // Find the DIY Difficulty Rating heading to position relative to it
    const difficultyTitle = document.querySelector('.difficulty-title');
    const difficultyWrapper = document.querySelector('.difficulty-wrapper');
    const targetElement = difficultyTitle || difficultyWrapper || disclaimerTrigger;
    const targetRect = targetElement.getBoundingClientRect();
    
    // Position 20px above the DIY Difficulty Rating heading
    let top = targetRect.top - popupHeight - 20;
    let left = difficultyWrapper ? difficultyWrapper.getBoundingClientRect().left : targetRect.left;
    
    // Adjust if popup would go off screen
    if (top < 10) {
      // Position below target if not enough space above
      top = targetRect.bottom + 20;
    }
    
    if (left + popupWidth > window.innerWidth - 10) {
      // Align to right edge of screen if would overflow
      left = window.innerWidth - popupWidth - 10;
    }
    
    if (left < 10) {
      left = 10;
    }
    
    disclaimerPopup.style.top = top + 'px';
    disclaimerPopup.style.left = left + 'px';
  }

  /**
   * Close disclaimer popup
   */
  function closeDisclaimerPopup() {
    const disclaimerPopup = document.getElementById('difficulty-disclaimer-popup');
    if (!disclaimerPopup) return;

    // Add closing animation
    disclaimerPopup.classList.add('is-closing');
    disclaimerPopup.classList.remove('is-active');
    
    // Hide popup after animation completes
    setTimeout(() => {
      disclaimerPopup.style.display = 'none';
      disclaimerPopup.classList.remove('is-closing');
    }, 300); // Match the CSS transition duration
  }
})();

